// TODO: Temporarly copied here, but the optimal soltion is to move this to the design-system package
// but we need to decide if the design system is okay to depend on next

import type { BoxProps } from '@adamdotai/design-system'
import { BaseLink } from '@adamdotai/design-system'
import NextLink from 'next/link'
import React from 'react'

type LinkProps = {
    isExternal?: boolean
    underline?: boolean
    isDisabled?: boolean
    isPrimary?: boolean
    href: string
    replace?: boolean
    shallow?: boolean
} & BoxProps &
    Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, 'href'>

const Link = ({
    children,
    isExternal,
    underline = true,
    href,
    replace = false,
    isDisabled = false,
    shallow = false,
    isPrimary = false,
    ...rest
}: React.PropsWithChildren<LinkProps>) => (
    <NextLink
        href={href}
        passHref={!isDisabled}
        replace={replace}
        shallow={shallow}
    >
        <BaseLink
            isExternal={isExternal}
            display="inline-flex"
            fontSize="inherit"
            {...(!underline && {
                _hover: { textDecoration: 'none' },
                _active: { textDecoration: 'none' },
            })}
            {...rest}
            {...(isDisabled && {
                cursor: 'not-allowed',
                opacity: '.6',
            })}
            {...(isPrimary && { color: 'primary.1000' })}
        >
            {children}
        </BaseLink>
    </NextLink>
)

export { Link }
